// import React from "react";
// import { Box, Card, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   ResponsiveContainer,
//   Tooltip,
// } from "recharts";

// const data = [
//   { name: "MON", high: 55, low: 10 },
//   { name: "TUE", high: 22, low: 5 },
//   { name: "WED", high: 45, low: 20 },
//   { name: "THU", high: 15, low: 10 },
//   { name: "FRI", high: 8, low: 3 },
//   { name: "SAT", high: 35, low: 18 },
//   { name: "SUN", high: 42, low: 22 },
// ];

// export default function WeeklyChart() {
//   const [mode, setMode] = React.useState("weekly"); 

//   const handleMode = (_: any, newMode: string) => {
//     if (newMode !== null) setMode(newMode);
//   };

//   return (
//     <Card
//       sx={{
//         p: 3,
//         borderRadius: 4,
//         boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//         width: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Box>
//           <Typography fontSize={14} color="grey.600">
//             Statistics
//           </Typography>

//           <Typography fontSize={18} fontWeight={600}>
//             Total summary of sales
//           </Typography>
//         </Box>

//         {/* Tabs */}
//         <ToggleButtonGroup
//           value={mode}
//           exclusive
//           onChange={handleMode}
//           size="small"
//           sx={{
//               gap: "0.2rem",
//               backgroundColor: "#f5f5f5",
//               borderRadius: "16px",
//               padding: "10px",
//               "& .MuiToggleButton-root": {
//                 border: "none",
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontWeight: 500,
//                 fontSize: "0.85rem",
//                 color: "#555",
//                 padding: "8px 17px",
//                 "&:hover": {
//                   backgroundColor: "#e0e0e0",
//                 },
//               },
//               "& .MuiToggleButton-root.Mui-selected": {
//                 backgroundColor: "#098963",
//                 color: "white",
//                 "&:hover": {
//                   backgroundColor: "#098963",
//                 },
//               },
//             }}
//         >
//           <ToggleButton value="daily">Daily</ToggleButton>
//           <ToggleButton value="weekly">Weekly</ToggleButton>
//           <ToggleButton value="monthly">Monthly</ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//      {/* Chart + Right Legend Wrapper */}
// <Box
//   display="flex"
//   justifyContent="space-between"
//   alignItems="center"
//   mt={3}
//   sx={{ width: "100%" }}
// >

//   {/* CHART */}
//   <Box sx={{ width: "80%", height: 320 }}>
//     <ResponsiveContainer width="100%" height="100%">
//       <BarChart data={data} barGap={8}>
//         <CartesianGrid
//           stroke="#E4E4E4"
//           strokeDasharray="3 3"
//           vertical={false}
//         />

//         <XAxis
//           dataKey="name"
//           tick={{ fontSize: 12, fill: "#6B7280" }}
//           axisLine={false}
//           tickLine={false}
//         />

//         <YAxis
//           tick={{ fontSize: 12, fill: "#6B7280" }}
//           axisLine={false}
//           tickLine={false}
//           tickFormatter={(v) => `${v}K`}
//         />

//         <Tooltip cursor={{ fill: "rgba(0,0,0,0.04)" }} />

//         <Bar
//           dataKey="high"
//           radius={[6, 6, 0, 0]}
//           fill="#D5B2FF"
//           maxBarSize={28}
//         />

//         <Bar
//           dataKey="low"
//           radius={[6, 6, 0, 0]}
//           fill="#4A1CFF"
//           maxBarSize={28}
//         />
//       </BarChart>
//     </ResponsiveContainer>
//   </Box>

//   {/* RIGHT SIDE LEGEND */}
//   <Box
//     display="flex"
//     flexDirection="column"
//     gap={2}
//     sx={{ pr: 2 }}
//   >
//     <Box display="flex" alignItems="center" gap={1}>
//       <Box sx={{ width: 12, height: 12, bgcolor: "#962DFF", borderRadius: "50%" }} />
//       <Typography fontSize={14} color="grey.700">Scanning – 37%</Typography>
//     </Box>

//     <Box display="flex" alignItems="center" gap={1}>
//       <Box sx={{ width: 12, height: 12, bgcolor: "#4A3AFF", borderRadius: "50%" }} />
//       <Typography fontSize={14} color="grey.700">Package – 23%</Typography>
//     </Box>

//     <Box display="flex" alignItems="center" gap={1}>
//       <Box sx={{ width: 12, height: 12, bgcolor: "#E0C6FD", borderRadius: "50%" }} />
//       <Typography fontSize={14} color="grey.700">Test – 29%</Typography>
//     </Box>
//   </Box>

// </Box>



//     </Card>
//   );
// }






import React, { useState, useEffect, useCallback } from "react";
import { Box, Card, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

interface SalesDataPoint {
  label: string;
  package: number;
  test: number;
  scanning: number;
}

interface ApiResponse {
  status: boolean;
  data: SalesDataPoint[];
}

export default function WeeklyRevenueChart() {
  const [mode, setMode] = useState<"daily" | "weekly" | "monthly">("weekly");
  const [chartData, setChartData] = useState<any[]>([]);
  const [labId, setLabId] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Dynamic complete lists
  const getCompleteWeekDays = () => ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const getCompleteMonths = () => ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

  // Get labId from local storage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setLabId(userId || "");
  }, []);

  // Map API labels to standard short format
  const normalizeLabel = (label: string, mode: string): string => {
    const normalized = label.toUpperCase().substring(0, 3);
    
    if (mode === "weekly") {
      const dayMap: Record<string, string> = {
        'SUN': 'SUN', 'MON': 'MON', 'TUE': 'TUE', 'WED': 'WED',
        'THU': 'THU', 'FRI': 'FRI', 'SAT': 'SAT',
        'SUNDAY': 'SUN', 'MONDAY': 'MON', 'TUESDAY': 'TUE', 
        'WEDNESDAY': 'WED', 'THURSDAY': 'THU', 'FRIDAY': 'FRI', 'SATURDAY': 'SAT'
      };
      return dayMap[normalized] || normalized;
    }
    
    if (mode === "monthly") {
      const monthMap: Record<string, string> = {
        'JAN': 'JAN', 'FEB': 'FEB', 'MAR': 'MAR', 'APR': 'APR',
        'MAY': 'MAY', 'JUN': 'JUN', 'JUL': 'JUL', 'AUG': 'AUG',
        'SEP': 'SEP', 'OCT': 'OCT', 'NOV': 'NOV', 'DEC': 'DEC',
        'JANUARY': 'JAN', 'FEBRUARY': 'FEB', 'MARCH': 'MAR'
      };
      return monthMap[normalized] || normalized;
    }
    
    return label;
  };

  // Fill missing periods dynamically
  const fillMissingData = (apiData: SalesDataPoint[], mode: string) => {
    const dataMap = new Map();
    
    apiData.forEach(item => {
      const normalizedKey = normalizeLabel(item.label, mode);
      dataMap.set(normalizedKey, {
        name: item.label,
        normalizedName: normalizedKey,
        high: item.test,
        low: item.scanning,
        package: item.package
      });
    });

    let completeData: any[] = [];
    
    if (mode === "weekly") {
      const weekDays = getCompleteWeekDays();
      completeData = weekDays.map(day => {
        const existing = dataMap.get(day);
        return existing || {
          name: day,
          normalizedName: day,
          high: 0,
          low: 0,
          package: 0
        };
      });
    } else if (mode === "monthly") {
      const months = getCompleteMonths();
      completeData = months.map(month => {
        const existing = dataMap.get(month);
        return existing || {
          name: month,
          normalizedName: month,
          high: 0,
          low: 0,
          package: 0
        };
      });
    } else {
      completeData = apiData.map(item => ({
        name: item.label,
        normalizedName: normalizeLabel(item.label, mode),
        high: item.test,
        low: item.scanning,
        package: item.package
      }));
    }

    return completeData;
  };

  const fetchSalesData = useCallback(async () => {
    if (!labId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError("");
      
      const rangeMap: Record<string, string> = {
        daily: "daily",
        weekly: "weekly",
        monthly: "monthly"
      };
      
      const response: ApiResponse = await http.get(
        `/lab/LabBooking/salesReport?labId=${labId}&range=${rangeMap[mode]}`
      );
      
      if (response.status && response.data) {
        const transformedData = fillMissingData(response.data, mode);
        setChartData(transformedData);
      } else {
        const skeletonData = mode === "weekly" 
          ? getCompleteWeekDays().map(day => ({ name: day, normalizedName: day, high: 0, low: 0, package: 0 }))
          : mode === "monthly"
          ? getCompleteMonths().map(month => ({ name: month, normalizedName: month, high: 0, low: 0, package: 0 }))
          : [];
        setChartData(skeletonData);
      }
    } catch (err: any) {
      console.error(`Error fetching ${mode} data:`, err);
      setError(`Failed to load ${mode} data`);
      const skeletonData = mode === "weekly" 
        ? getCompleteWeekDays().map(day => ({ name: day, normalizedName: day, high: 0, low: 0, package: 0 }))
        : mode === "monthly"
        ? getCompleteMonths().map(month => ({ name: month, normalizedName: month, high: 0, low: 0, package: 0 }))
        : [];
      setChartData(skeletonData);
    } finally {
      setLoading(false);
    }
  }, [labId, mode]);

  useEffect(() => {
    fetchSalesData();
  }, [fetchSalesData]);

  const handleModeChange = (_: any, newMode: string | null) => {
    if (newMode && (newMode === "daily" || newMode === "weekly" || newMode === "monthly")) {
      setMode(newMode as "daily" | "weekly" | "monthly");
    }
  };

  // Calculate totals
  const testTotal = chartData.reduce((sum, item) => sum + (item?.high || 0), 0);
  const scanningTotal = chartData.reduce((sum, item) => sum + (item?.low || 0), 0);
  const packageTotal = chartData.reduce((sum, item) => sum + (item?.package || 0), 0);

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        width: "100%",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography fontSize={14} color="grey.600">
            Statistics
          </Typography>
          <Typography fontSize={18} fontWeight={600}>
            Total summary of sales
          </Typography>
        </Box>

        {/* ORIGINAL ToggleButtonGroup styling restored */}
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={handleModeChange}
          size="small"
          sx={{
            gap: "0.2rem",
            backgroundColor: "#f5f5f5",
            borderRadius: "16px",
            padding: "10px",
            "& .MuiToggleButton-root": {
              border: "none",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.85rem",
              color: "#555",
              padding: "8px 17px",
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            },
            "& .MuiToggleButton-root.Mui-selected": {
              backgroundColor: "#098963",
              color: "white",
              "&:hover": {
                backgroundColor: "#098963",
              },
            },
          }}
        >
          <ToggleButton value="daily">Daily</ToggleButton>
          <ToggleButton value="weekly">Weekly</ToggleButton>
          <ToggleButton value="monthly">Monthly</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Chart + Legend Wrapper */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={3}
        sx={{ width: "100%" }}
      >
        {/* CHART */}
        <Box sx={{ width: "80%", height: 320 }}>
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              sx={{ color: "grey.500" }}
            >
              <Typography>Loading {mode} data...</Typography>
            </Box>
          ) : error ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              sx={{ color: "error.main" }}
            >
              <Typography>{error}</Typography>
            </Box>
          ) : chartData.length === 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              height="100%"
              sx={{ color: "grey.500", textAlign: "center" }}
            >
              <Typography>No {mode} sales data available</Typography>
              <Typography variant="caption">Try switching to another period</Typography>
            </Box>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData} barGap={8}>
                <CartesianGrid
                  stroke="#E4E4E4"
                  strokeDasharray="3 3"
                  vertical={false}
                />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 12, fill: "#6B7280" }}
                  axisLine={false}
                  tickLine={false}
                  interval={0}
                  angle={mode === "weekly" ? -45 : 0}
                  height={mode === "weekly" ? 65 : 45}
                />
                <YAxis
                  tick={{ fontSize: 12, fill: "#6B7280" }}
                  axisLine={false}
                  tickLine={false}
                  tickFormatter={(v) => `₹${(v / 1000).toFixed(1)}K`}
                />
                <Tooltip 
                  cursor={{ fill: "rgba(0,0,0,0.04)" }}
                  formatter={(value: number, name: string) => [
                    `₹${value.toLocaleString()}`,
                    name === "high" ? "Test" : name === "low" ? "Scanning" : "Package"
                  ]}
                />
                <Bar
                  dataKey="high"
                  radius={[6, 6, 0, 0]}
                  fill="#D5B2FF"
                  maxBarSize={28}
                  name="Test"
                />
                <Bar
                  dataKey="low"
                  radius={[6, 6, 0, 0]}
                  fill="#4A1CFF"
                  maxBarSize={28}
                  name="Scanning"
                />
              </BarChart>
            </ResponsiveContainer>
          )}
        </Box>

        {/* RIGHT SIDE LEGEND */}
        <Box display="flex" flexDirection="column" gap={2} sx={{ pr: 2 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 12, height: 12, bgcolor: "#962DFF", borderRadius: "50%" }} />
            <Typography fontSize={14} color="grey.700">
              Test – ₹{testTotal.toLocaleString()}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 12, height: 12, bgcolor: "#4A3AFF", borderRadius: "50%" }} />
            <Typography fontSize={14} color="grey.700">
              Scanning – ₹{scanningTotal.toLocaleString()}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 12, height: 12, bgcolor: "#E0C6FD", borderRadius: "50%" }} />
            <Typography fontSize={14} color="grey.700">
              Package – ₹{packageTotal.toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
